import React, {useState, useEffect} from 'react';
import { Image, Card, Accordion } from 'react-bootstrap';
import { semesters } from '../objects';
export default function Education(){
    const [semesterIdx, setSemesterIdx] = useState(-1);
  const [hoverIdx, setHoverIdx] = useState(-1);
    let reversedSemesters = [...semesters].reverse();

    useEffect(() => {
    // If no valid semester index, do nothing
    if(semesterIdx < 0) return;

    const inputElement = document.getElementById(`semesterDescription${semesterIdx}`);
    if(inputElement){
      // Smoothly scroll the card into view and make sure it can receive focus
      try{
        inputElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch(e) {
        // fallback: ignore if scroll fails in some environments
      }
      if(typeof inputElement.focus === 'function'){
        inputElement.focus();
      }
      console.log(inputElement)
    }
    }, [semesterIdx])

    const folderStyle = {
        width: '60vmin',
        height: '60vmin',
        background: 'linear-gradient(135deg, rgba(210,210,214,1) 0%, rgba(197,197,200,1) 45%, rgba(180,180,184,1) 100%)',
        borderRadius: '48px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
        display: 'flex',
        flexWrap: 'wrap', 
        justifyContent: 'flex-start', 
        alignItems: 'flex-start', 
        padding: 20,
        overflow: 'hidden',
      };
    

  const widgetStyle = {
    width: '60vmin',
    height: '60vmin',
    background: 'linear-gradient(135deg, rgba(210,210,214,1) 0%, rgba(197,197,200,1) 45%, rgba(180,180,184,1) 100%)',
    borderRadius: '48px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
    padding: 30
  };
  const widgetTitle = {
    display: "flex",
    flexDirection: "row",
    marginBottom: 20
    // alignItems: "",
  }
  const widgetTitleText = {
    display: "flex",
    flexDirection: "column"
  }
  const pageContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
  }
  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    margin: 100,
  }
  const appStyle = {
    width: '13vmin',
    height: '13vmin',
    borderRadius: 18,
    marginRight: '2.5vmin',
    marginLeft: '2.5vmin',
    backgroundColor:'#9A2A2A',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'transform 160ms ease, box-shadow 160ms ease',
    boxShadow: '0 6px 18px rgba(0,0,0,0.12)'

  }
  const appContainer = {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  }
  const appNameText = {
    color: "white",
    fontSize: '2.4rem',
    fontWeight: 700,
    userSelect: 'none'
  }
  const semesterSummary = {
    // display: 'flex',
    // alignItems: 'center',
    // flexDirection: 'column',
    margin: 60
  }

  return (
    <div>
        <div style={pageContainerStyle}>
        <div style={containerStyle}>
            <div style={folderStyle}>
            {
                reversedSemesters.map((s, index) => (
                <div style={appContainer} key={index}>
                    <div
                      style={{
                        ...appStyle,
                        ...(index === hoverIdx || index === semesterIdx ? { transform: 'scale(1.06)', boxShadow: '0 14px 34px rgba(0,0,0,0.30)' } : {})
                      }}
                      className='blur-image'
                      onClick={() => { setSemesterIdx(index) }}
                      onMouseEnter={() => setHoverIdx(index)}
                      onMouseLeave={() => setHoverIdx(-1)}
                      aria-pressed={semesterIdx === index}
                    >
                        <h1 style={appNameText}>{s.iconAbv}</h1>
                    </div>
                    <p style={{ marginTop: 8, fontWeight: 600, color: '#222' }}>{s.iconName}</p>
                </div>
                ))
            }
            </div>
            <h1 className="white-text">Semesters</h1>
            <h4 className="white-text" style={{ fontStyle: 'italic', fontSize: '0.85em' }}>*Click to see more!</h4>

        </div>
        <div style={containerStyle}>
            <div style={widgetStyle}>
                <div>
                    <div style={widgetTitle}>
                        <Image src={"bucky.jpg"} style={appStyle} className='blur-image' onClick={() => {
                            window.location.href = "https://www.wisc.edu/"
                        }}></Image>
                        <div style={widgetTitleText}>
                            <h2>UW Madison</h2>
                            
                        </div>
                    </div> 
                    <div>
                    <p><strong>Major:</strong> Computer Science and Finance</p>
                            <p><strong>Graduation Date:</strong> May 2025</p>
                            <p><strong>GPA:</strong> 3.7</p>
                            <p><strong>Skills:</strong> Java, Python, C, React, SQL, Algorithms, Data Structures, Operating Systems, AI, Databases, Derivitave Securities, Excel, Financial Markets, Crypto, Portfolio Management</p>
                    </div>
                </div>
            </div>
        </div>
        </div>
    {semesterIdx >=0 ? <Card className="mb-4 " style={semesterSummary} id={`semesterDescription${semesterIdx}`} tabIndex={-1} >
            <Card.Header>
                <h2>{ reversedSemesters[semesterIdx].termDescription }</h2>
            </Card.Header>
                    <Accordion>
                    {
                        reversedSemesters[semesterIdx].courses.map((c, i) => (
                            <Accordion.Item eventKey={i} key={i}>
                                <Accordion.Header>{c.courseShortDescription} {c.courseNum} - {c.courseDescription}</Accordion.Header>
                                <Accordion.Body>
                                    <p><strong>Description:</strong> {c.description}</p>
                                    <p><strong>Credits:</strong> {c.credits}</p>

                                </Accordion.Body>
                            </Accordion.Item>
                        ))
                    }
                    </Accordion>
        </Card> : <></>}
    </div>
  );
}